import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { AppErrorBoundary, type AppErrorBoundaryProps } from './AppErrorBoundary';

type Props = Omit<AppErrorBoundaryProps, 'scope' | 'resetKey'>;

/**
 * Page-scoped error boundary for a layout's `<Outlet />`.
 *
 * Keys the boundary on the current pathname so that once a page has crashed,
 * clicking any other navbar / sidebar link renders the new page normally
 * instead of leaving the stale fallback on screen. Must be rendered inside
 * the router.
 */
export function RouteErrorBoundary({ children, ...rest }: Props & { children: ReactNode }) {
  const location = useLocation();
  return (
    <AppErrorBoundary scope="page" resetKey={location.pathname} {...rest}>
      {children}
    </AppErrorBoundary>
  );
}

export default RouteErrorBoundary;
